"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackProductListItems = exports.trackProducts = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function getPackagingProduct(item) {
    const additionalProducts = [];
    if ('packaging' in item && item.packaging) {
        const packagingTitle = item.packaging.title;
        if (packagingTitle) {
            const packagingProductInfo = {
                ID: packagingTitle,
                name: packagingTitle,
                manufacturerSKU: item.packaging.manufacturerSku,
                price: item.packaging.price.gross.amount,
                currency: item.packaging.price.gross.currencyCode,
            };
            additionalProducts.push(packagingProductInfo);
        }
    }
    else if ('selectedPackaging' in item && item.selectedPackaging) {
        const packagingProductInfo = {
            ID: item.selectedPackaging.title,
            name: item.selectedPackaging.title,
            manufacturerSKU: item.selectedPackaging.variantId,
            price: item.selectedPackaging.price.gross.amount,
            currency: item.selectedPackaging.price.gross.currencyCode,
        };
        additionalProducts.push(packagingProductInfo);
    }
    return additionalProducts;
}
function getProduct(item, baseUrl) {
    let imageURL;
    if ('image' in item.product && item.product.image) {
        const { image } = item.product;
        imageURL =
            'largeUrl' in image
                ? image.largeUrl
                : 'image' in image
                    ? image.image.originalSrc
                    : image.url;
    }
    return {
        ID: item.product.trackingName,
        name: item.product.title,
        manufacturerSKU: item.product.manufacturerSku,
        URL: 'url' in item.product && item.product.url
            ? `${baseUrl}/${item.product.url.replace(/^\//, '')}`
            : undefined,
        imageURL,
        price: item.product.price.gross.amount,
        currency: item.product.price.gross.currencyCode,
    };
}
function trackProducts(items, baseUrl) {
    if (!items || !items.length) {
        return;
    }
    const packagingProducts = items.flatMap(item => getPackagingProduct(item));
    const regularProducts = items.map(item => getProduct(item, baseUrl));
    const allProducts = [...regularProducts, ...packagingProducts];
    (0, pushToDataLayer_1.pushToDataLayer)({
        Products: allProducts,
    });
}
exports.trackProducts = trackProducts;
function trackProductListItems(baseUrl, items) {
    if (!items?.length) {
        return;
    }
    (0, pushToDataLayer_1.pushToDataLayer)({
        Products: items.map(item => ({
            ID: item.trackingName,
            name: item.title,
            manufacturerSKU: item.manufacturerSku,
            URL: baseUrl + item.url,
            imageURL: item.images?.[0].url,
            price: Number.parseFloat(item.price.gross.amount),
            currency: item.price.gross.currencyCode,
        })),
    });
}
exports.trackProductListItems = trackProductListItems;
//# sourceMappingURL=trackProducts.js.map